<script lang="ts">
  import { writable } from 'svelte/store'
  import { Link } from 'svelte-navigator'
  import Modal from 'svelte-simple-modal'

  import { ROUTES } from '../constants/constants'
  import { surveyStatus } from '../stores'
  import HeaderLogos from './HeaderLogos.svelte'
  import HomeLink from './HomeLink.svelte'
  import AboutModal from './AboutModal.svelte'

  let carousel
  let aboutModal = writable(null)
</script>

<Modal
  show={$aboutModal}
  styleContent={{ padding: '1.5rem' }}
  styleCloseButton={{ boxShadow: 'none', background: '#e4e4e4' }}
/>

<div class="home-wrapper">
  <button class="dropdown-current-label" type="button">
    Home
    <button class="dropdown-item chi-siamo" on:click={() => aboutModal.set(AboutModal)}
      >Chi siamo</button
    >
  </button>

  <div class="banner" />

  {#if $surveyStatus.userAnswersList.length < 18}
    <Link to={ROUTES.survey}>
      <button
        >Partecipa al sondaggio<span
          ><svg
            width="18"
            height="19"
            viewBox="0 0 18 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.475 2C17.475 1.26225 16.8769 0.664189 16.1392 0.664189L4.11689 0.664189C3.37914 0.664189 2.78108 1.26225 2.78108 2C2.78108 2.73775 3.37914 3.33581 4.11689 3.33581L14.8034 3.33581V14.0223C14.8034 14.76 15.4014 15.3581 16.1392 15.3581C16.8769 15.3581 17.475 14.76 17.475 14.0223V2ZM1.94456 18.0837L17.0837 2.94456L15.1946 1.05544L0.0554392 16.1946L1.94456 18.0837Z"
              fill="black"
            />
          </svg>
        </span>
      </button></Link
    >
  {:else}
    <button style="cursor: initial">Grazie per aver partecipato!</button>
  {/if}

  <div class="links-grid">
    <HomeLink route={ROUTES.dataWall} title="Ritratti di mobilità" />
    <HomeLink route={ROUTES.results} title="Risultati del sondaggio" />
    <HomeLink route={ROUTES.insights} title="Analisi delle risposte" />
    <HomeLink route={ROUTES.bestPractices} title="Buone pratiche" />
    <HomeLink route={ROUTES.usefulResources} title="Migliora il tuo impatto" />
  </div>

  <HeaderLogos />
</div>

<style>
  .home-wrapper {
    width: 100%;
    /*     min-height: 100vh; */
  }

  .banner {
    min-height: 40vh;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    animation: bgImage 20s infinite ease-in;
  }

  .links-grid {
    min-height: calc(60vh - 55px - 60px - 8vh);
    font-size: 18px;
    font-weight: 600;
  }

  button {
    cursor: pointer;
    height: 60px;
    display: flex;
    justify-content: space-between;
    border: none;
    border-radius: 0;
    padding: 1.2rem 1.5rem;
    margin: 0;
    color: black;
    font-weight: 700;
    font-size: 18px;
    background-color: #00fff0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  button span {
    padding: 1.2rem 0;
    display: flex;
    align-items: center;
  }

  .dropdown-current-label {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100vw;
    margin: 0;
    background: #313131;
    border: none;
    border-radius: 0;
    color: #ffffff;
    text-align: left;
    height: 55px;
    font-size: 22px;
    font-weight: 600;
    padding: 0.4rem 1.5rem;
  }

  .chi-siamo {
    width: max-content;
    height: max-content;
    color: inherit;
    border: none;
    font: inherit;
    cursor: pointer;
    outline: inherit;
    font-size: 12px;
    padding: 0.3rem 0.5rem;
    background-color: #595959;
    border-radius: 50px;
  }

  @keyframes bgImage {
    0% {
      background-image: url('/img/foto-1.jpg');
    }

    20% {
      background-image: url('/img/foto-2.jpg');
    }

    40% {
      background-image: url('/img/foto-3.jpg');
    }

    60% {
      background-image: url('/img/foto-4.jpg');
    }

    80% {
      background-image: url('/img/foto-5.jpg');
    }

    100% {
      background-image: url('/img/foto-1.jpg');
    }
  }

  @media (max-width: 520px) {
    .links-grid {
      min-height: calc(60vh - 55px - 60px - 5vh);
    }
  }
</style>
